import React from 'react';
import { Particles } from './animations/Particles';
import { Beams } from './animations/Beams';
import { Squares } from './animations/Squares';
import { Threads } from './animations/Threads';
import { OrbitField } from './animations/OrbitField';
import { Lightning } from './animations/Lightning';
import { Waves } from './animations/Waves';
import { Aurora } from './animations/Aurora';
export type FxVariant = 'particles' | 'beams' | 'squares' | 'threads' | 'orbit' | 'orbit-left' | 'orbit-right' | 'lightning' | 'waves' | 'aurora' | 'aurora-particles' | 'beams-squares' | 'none';
interface SectionFxProps {
  variant: FxVariant;
  className?: string;
}
/**
 * Renders an animated background appropriate for the requested variant.
 * Composes primitives so each section gets its own atmospheric treatment.
 *
 * All variants are absolutely positioned and pointer-events: none so they
 * sit behind section content without interfering with interactions.
 */
export function SectionFx({
  variant,
  className = ''
}: SectionFxProps) {
  return <div className={`absolute inset-0 pointer-events-none ${className}`} data-id="element-783">
      {variant === 'particles' && <Particles count={70} data-id="element-784" />}
      {variant === 'beams' && <Beams count={6} data-id="element-785" />}
      {variant === 'squares' && <Squares lit={14} data-id="element-786" />}
      {variant === 'threads' && <Threads count={7} data-id="element-787" />}
      {variant === 'orbit' && <OrbitField center={{
      x: 50,
      y: 50
    }} size={500} data-id="element-788" />}
      {variant === 'orbit-left' && <OrbitField center={{
      x: 15,
      y: 50
    }} size={420} count={3} data-id="element-789" />}
      {variant === 'orbit-right' && <OrbitField center={{
      x: 85,
      y: 50
    }} size={420} count={3} data-id="element-790" />}
      {variant === 'lightning' && <Lightning interval={3} data-id="element-791" />}
      {variant === 'waves' && <Waves count={4} data-id="element-792" />}
      {variant === 'aurora' && <Aurora intensity={0.25} data-id="element-793" />}

      {variant === 'aurora-particles' && <>
          <Aurora intensity={0.2} data-id="element-794" />
          <Particles count={50} data-id="element-795" />
        </>}
      {variant === 'beams-squares' && <>
          <Squares lit={10} data-id="element-796" />
          <Beams count={4} data-id="element-797" />
        </>}

      {/* Subtle dark vignette so content stays readable */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, transparent 30%, rgba(5,6,8,0.5) 90%)'
    }} data-id="element-798" />
    </div>;
}